<script setup lang="ts">
import { provide, ref } from 'vue';

const openSubmenu = ref<string | null>(null);

const setOpenSubmenu = (submenuId: string | null) => {
  openSubmenu.value = submenuId;
};

provide('openSubmenu', openSubmenu);
provide('setOpenSubmenu', setOpenSubmenu);

const slots = defineSlots<{
  default(props: object): any;
}>();
</script>

<template>
  <div class="shadow-menu-s flex flex-col gap-[2px] rounded-8 bg-white p-[6px] dark:bg-gray-900">
    <slot name="default"></slot>
  </div>
</template>
